export const SLA_VIOLATION = {
	FORA_DO_PRAZO: 0,
	DENTRO_DO_PRAZO: 1,
};
